import { proNavigator } from "single-spa/react-app/ProNavigator";
import type { RouterStateConfig } from "single-spa/react-app/router/IRouterState";

import { ROUTES as displayAdvertisingRoutes } from "../displayAdvertising/displayAdvertisingConstants";
import { ROUTES as searchAdvertisingRoutes } from "../searchAdvertising/searchAdvertisingConstants";

export const advertiserActivityFutureConfig: RouterStateConfig = {
    "adintelligence-advertiseractivity.**": {
        url: "/advertiseractivity",
        lazyLoad: async () => {
            // prefetch display advertising and search advertising modules
            await Promise.allSettled([
                proNavigator.lazyLoadIfNeeded(displayAdvertisingRoutes.overview.stateName),
                proNavigator.lazyLoadIfNeeded(searchAdvertisingRoutes.landingPages),
            ]);
            return import("../advertiserActivity/advertiserActivityConfig");
        },
    },
};

export const displayAdvertisingFutureConfig: RouterStateConfig = {
    "adintelligence-displayadvertising.**": {
        url: "/displayadvertising",
        lazyLoad: () => import("../displayAdvertising/displayAdvertisingConfig"),
    },
};

export const searchAdvertisingFutureConfig: RouterStateConfig = {
    "adintelligence-searchadvertising.**": {
        url: "/searchadvertising",
        lazyLoad: () => import("../searchAdvertising/searchAdvertisingConfig"),
    },
};

export const publisherAnalysisFutureConfig: RouterStateConfig = {
    "adintelligence-publisheranalysis.**": {
        url: "/publisheranalysis",
        lazyLoad: () => import("../publisherAnalysis/publisherAnalysisConfig"),
    },
};

export const socialChannelsFutureConfig = {
    "social-channels.**": {
        url: "/social-channels",
        lazyLoad: () => import("../social-channels/configs"),
    },
};

export const aiChannelsFutureConfig = {
    "ai-channels.**": {
        url: "/ai-channels",
        lazyLoad: () => import("../ai-channels/configs"),
    },
};

// Pre-rename URLs. The same module is loaded, and its legacy states redirect to their
// `ai-channels` twin.
export const llmsChannelsFutureConfig = {
    "llms-channels.**": {
        url: "/llms-channels",
        lazyLoad: () => import("../ai-channels/configs"),
    },
};

export const adTrackerFutureConfig: RouterStateConfig = {
    "adtracker.**": {
        url: "/adtracker",
        lazyLoad: () => import("../adTracker/adTrackerConfig"),
    },
};

export const monitorAndProtectFutureConfig: RouterStateConfig = {
    "monitorandprotect.**": {
        url: "/monitorandprotect",
        lazyLoad: () => import("../monitor-and-protect/configs"),
    },
};
